import { memo, ReactElement } from 'react';
import { IMenuItem } from 'models/IMenuItem';
import { NO_ELEMENT } from 'utils';
import { IconSectionN } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionN';
import { IconSectionO } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionO';
import { IconSectionP } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionP';
import { IconSectionQ } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionQ';
import { IconSectionR } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionR';
import { IconSectionU } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionU';
import { IconSectionY } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionY';
import { IconSectionZ } from 'components/Shared/Icon/themes/BGH-RD3/iconSectionZ';
import styles from './styles.scss';

const sectionIcons: { [key: string]: ReactElement } = {
  N: <IconSectionN key="n" />,
  O: <IconSectionO key="o" />,
  P: <IconSectionP key="p" />,
  Q: <IconSectionQ key="q" />,
  R: <IconSectionR key="r" />,
  U: <IconSectionU key="u" />,
  Y: <IconSectionY key="y" />,
  Z: <IconSectionZ key="z" />
};

export default memo(({ id }: IMenuItem) => {
  return <div className={styles.icon}>{sectionIcons[id.substr(-1)] || NO_ELEMENT}</div>;
});
